module.exports = [
  {
    title: "بلاگ",
    link: "/blog"
  },
  {
    title: "فرصت‌های شغلی",
    link: "https://career.snapp.ir"
  },
  {
    title: "درباره ما",
    link: "/about"
  },
  {
    title: "تماس با ما",
    link: "/contact"
  },
  {
    title: "پیوستن به ناوگان اسنپ",
    link: "https://digitalsignup.snapp.ir/?utm_source=snapp.ir&utm_medium=website-button&utm_campaign=ws-redirect-august2021"
  },
  {
    title: "پنل سازمانی",
    link: "https://corporate.snapp.ir",
    target: "_blank"
  },
  {
    title: "باشگاه رانندگان",
    link: "https://club.snapp.ir",
    target: "_blank",
    className: "club"
  }
];



// WEBPACK FOOTER //
// ./src/js/config/HeaderLinks.js